<template>
  <b-sidebar
      id="add-sidebar"
      :visible="isAddSidebarActive"
      bg-variant="white"
      sidebar-class="sidebar-lg"
      shadow
      backdrop
      no-header
      right
      @hidden="resetForm"
      @change="(val) => $emit('update:is-add-sidebar-active', val)"
  >

    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Tambah Task Baru
        </h5>

        <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
          #default="{ handleSubmit }"
          ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
            class="p-2"
            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm"
        >

          <!-- Tanggal -->
          <validation-provider
              #default="validationContext"
              name="Tanggal"
              rules="required"
          >
            <b-form-group
                label="Tanggal"
                label-for="tanggal">
              <flat-pickr
                  id="tanggal"
                  v-model="data.tanggal"
                  class="form-control"
                  :config="{ maxDate: 'today' }"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>


          <!-- Detail -->
          <validation-provider
              #default="validationContext"
              name="Detail"
              rules="required"
          >
            <b-form-group
                label="Detail"
                label-for="full-name"
            >
              <b-form-textarea
                  id="detail"
                  v-model="data.detail"
                  :state="getValidationState(validationContext)"
                  trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

<!--          <validation-provider-->
<!--              #default="validationContext"-->
<!--              name="Bukti Foto"-->
<!--              rules="required"-->
<!--          >-->
<!--            <b-form-group-->
<!--                label="Bukti Foto"-->
<!--                label-for="foto"-->
<!--                :state="getValidationState(validationContext)"-->
<!--            >-->
<!--              <b-form-file-->
<!--                  id="foto"-->
<!--                  accept="image/*"-->
<!--                  v-model="data.foto"-->
<!--              />-->
<!--              <b-form-invalid-feedback :state="getValidationState(validationContext)">-->
<!--                {{ validationContext.errors[0] }}-->
<!--              </b-form-invalid-feedback>-->
<!--            </b-form-group>-->
<!--          </validation-provider>-->

          <img v-if="data.fotoBase64" :src="data.fotoBase64" alt="Foto Profil" class="img-thumbnail">

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                type="submit"
            >
              Tambah
            </b-button>
            <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
            >
              Batal
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BFormTextarea, BFormFile
} from 'bootstrap-vue'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {ref} from '@vue/composition-api'
import {required, alphaNum, email} from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from "vue-flatpickr-component"
import store from '@/store'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormFile,
    BFormTextarea,
    vSelect,
    flatPickr,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddSidebarActive',
    event: 'update:is-add-sidebar-active',
  },
  props: {
    isAddSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      dateRange: new Date().fp_incr(1)
    }
  },
  setup(props, {emit}) {
    const blankData = {
      detail: '',
      tanggal: '',
      foto: null,
      fotoBase64: null,
    }

    const data = ref(JSON.parse(JSON.stringify(blankData)))
    const resetData = () => {
      data.value = JSON.parse(JSON.stringify(blankData))
    }

    const onSubmit = () => {
      store.dispatch('app-task/add', data.value)
          .then(() => {
            emit('refetch-data')
            emit('update:is-add-sidebar-active', false)
          })
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetData)

    return {
      data,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
  watch: {
    'data.foto': {
      deep: true,
      handler(val, oldVal) {
        if (val) {
          this.createBase64Image(val)
        } else {
          self.fotoBase64 = null
        }
      }
    },
  },
  methods: {
    createBase64Image: function (fileObject) {
      const self = this;
      const reader = new FileReader()
      reader.onload = function (e) {
        self.data.fotoBase64 = e.target.result
      }
      reader.readAsDataURL(fileObject);
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';


#add-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
